<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>検索結果</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div style="overflow-x: hidden; overflow-y: auto">
            <table id="searchResult" mat-table multiTemplateDataRows [dataSource]="dataSource"
                style="width: 100%; border: solid 1px rgba(0, 0, 0, 0.12);">
                <ng-container matColumnDef="select">
                    <th mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef style="width: 2em;">
                        選択</th>
                    <td mat-cell *matCellDef="let row" class="text-center">
                        <mat-radio-button name="azukarikinFurikaeRadioGroup" color="primary" [checked]=true>
                        </mat-radio-button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="recptFixNo">
                    <th mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width:120px;">
                        支払契約番号</th>
                    <td mat-cell *matCellDef="let e">{{ e.visitornumber }}</td>
                </ng-container>
                <ng-container matColumnDef="visitName">
                    <th mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width:85px;">請求先名
                    </th>
                    <td mat-cell *matCellDef="let e">{{ e.visitName }}</td>
                </ng-container>
                <ng-container matColumnDef="telNo">
                    <th mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width:105px">電話番号
                    </th>
                    <td mat-cell *matCellDef="let e">{{ e.telNo1 }}</td>
                </ng-container>
                <ng-container matColumnDef="sazvjjsKanjiAname">
                    <th mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width:280px;">住所
                    </th>
                    <td mat-cell *matCellDef="let e">
                        {{ e.addr }}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displaySearchedColumns; sticky: true;"></tr>
                <tr mat-row *matRowDef="let row; columns: displaySearchedColumns ;"></tr>

            </table>
        </div>
        <div>
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
                <mat-card-actions class="btn_area_right">
                    <button type="button" mat-raised-button color="primary" class="btn"
                        (click)="onClickRegist()">登録</button>
                </mat-card-actions>
            </div>
        </div>

    </mat-card-content>
</mat-card>